var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5472",
    "data-name": "Rectangle 5472",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M15,20H5V7A1,1,0,0,0,4,6H4A1,1,0,0,0,3,7V20a2.006,2.006,0,0,0,2,2H15a1,1,0,0,0,1-1h0A1,1,0,0,0,15,20Zm5-4V4a2.006,2.006,0,0,0-2-2H9A2.006,2.006,0,0,0,7,4V16a2.006,2.006,0,0,0,2,2h9A2.006,2.006,0,0,0,20,16Zm-2,0H9V4h9Z",
    transform: "translate(-3 -2)",
    fill: "#0078d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.31e9c06944737952fb6149912de537be.svg";
export { ForwardRef as ReactComponent };